let seq = 0;
const queue = $state([]);
export const dialogState = {
  get current() {
    return queue[0];
  },
  get open() {
    return queue.length > 0;
  }
};
function enqueue(d) {
  queue.push({ ...d, id: ++seq });
}
function accept(value) {
  const d = queue.shift();
  if (!d) return;
  if (d.kind === "prompt") d.resolve(value ?? "");
  else if (d.kind === "confirm") d.resolve(true);
  else d.resolve(void 0);
}
function cancel() {
  const d = queue.shift();
  if (!d) return;
  if (d.kind === "prompt") d.resolve(null);
  else if (d.kind === "confirm") d.resolve(false);
  else d.resolve(void 0);
}
export const dialogActions = { accept, cancel };
function asOptions(opts) {
  return typeof opts === "string" ? { message: opts } : opts;
}
export const dialogs = {
  alert(opts) {
    const o = asOptions(opts);
    return new Promise((resolve) => {
      enqueue({
        kind: "alert",
        title: o.title ?? "",
        message: o.message ?? "",
        okLabel: o.okLabel ?? "OK",
        cancelLabel: "",
        tone: o.tone ?? "default",
        defaultValue: "",
        placeholder: "",
        inputType: "text",
        resolve: () => resolve()
      });
    });
  },
  confirm(opts) {
    const o = asOptions(opts);
    return new Promise((resolve) => {
      enqueue({
        kind: "confirm",
        title: o.title ?? "",
        message: o.message ?? "",
        okLabel: o.confirmLabel ?? "OK",
        cancelLabel: o.cancelLabel ?? "Cancel",
        tone: o.tone ?? "default",
        defaultValue: "",
        placeholder: "",
        inputType: "text",
        resolve: (v) => resolve(v === true)
      });
    });
  },
  prompt(opts) {
    const o = asOptions(opts);
    return new Promise((resolve) => {
      enqueue({
        kind: "prompt",
        title: o.title ?? "",
        message: o.message ?? "",
        okLabel: o.confirmLabel ?? "OK",
        cancelLabel: o.cancelLabel ?? "Cancel",
        tone: "default",
        defaultValue: o.defaultValue ?? "",
        placeholder: o.placeholder ?? "",
        inputType: o.inputType ?? "text",
        resolve: (v) => resolve(typeof v === "string" ? v : null)
      });
    });
  }
};
